const SITE_URL = "https://www.mangosoftwarehouse.com";
const DEFAULT_PAGE_TITLE = "Mango Software House · Software sob medida, automação e sistemas para PME";
const DEFAULT_PAGE_DESCRIPTION = "Software sob medida, automação de processos e sites para pequenas e médias empresas em todo o Brasil e em Portugal. Diagnóstico inicial sem custo.";
const DEFAULT_OG_DESCRIPTION = "Software sob medida, automação de processos e sites para pequenas e médias empresas em todo o Brasil e em Portugal. Diagnóstico inicial sem custo.";
const DEFAULT_KEYWORDS = "Mango Software House, software sob medida, automação de processos, sites e landing pages, consultoria de TI, QA e testes, open source";

function setMetaTag(selector, attributes) {
    if (typeof document === "undefined") {
        return;
    }

    let element = document.head.querySelector(selector);

    if (!element) {
        element = document.createElement("meta");
        document.head.appendChild(element);
    }

    Object.entries(attributes).forEach(([attribute, value]) => {
        element.setAttribute(attribute, value);
    });
}

function removeMetaTag(selector) {
    if (typeof document === "undefined") {
        return;
    }

    const element = document.head.querySelector(selector);

    if (element) {
        element.remove();
    }
}

function setLinkTag(selector, attributes) {
    if (typeof document === "undefined") {
        return;
    }

    let element = document.head.querySelector(selector);

    if (!element) {
        element = document.createElement("link");
        document.head.appendChild(element);
    }

    Object.entries(attributes).forEach(([attribute, value]) => {
        element.setAttribute(attribute, value);
    });
}

function setStructuredData(id, payload) {
    if (typeof document === "undefined") {
        return;
    }

    let element = document.getElementById(id);

    if (!element) {
        element = document.createElement("script");
        element.id = id;
        element.type = "application/ld+json";
        document.head.appendChild(element);
    }

    element.textContent = JSON.stringify(payload);
}

function removeStructuredData(id) {
    if (typeof document === "undefined") {
        return;
    }

    const element = document.getElementById(id);

    if (element) {
        element.remove();
    }
}

function absoluteUrl(path) {
    if (!path) {
        return SITE_URL;
    }

    if (/^https?:\/\//.test(path)) {
        return path;
    }

    return `${SITE_URL}${path.startsWith("/") ? "" : "/"}${path}`;
}

function restoreDefaultMeta() {
    document.title = DEFAULT_PAGE_TITLE;

    setMetaTag('meta[name="description"]', {
        name: "description",
        content: DEFAULT_PAGE_DESCRIPTION
    });
    setMetaTag('meta[name="keywords"]', {
        name: "keywords",
        content: DEFAULT_KEYWORDS
    });
    setMetaTag('meta[property="og:title"]', {
        property: "og:title",
        content: DEFAULT_PAGE_TITLE
    });
    setMetaTag('meta[property="og:description"]', {
        property: "og:description",
        content: DEFAULT_OG_DESCRIPTION
    });
    setMetaTag('meta[property="og:type"]', {
        property: "og:type",
        content: "website"
    });
    setMetaTag('meta[property="og:site_name"]', {
        property: "og:site_name",
        content: "Mango Software House"
    });
    setMetaTag('meta[property="og:locale"]', {
        property: "og:locale",
        content: "pt_BR"
    });
    setMetaTag('meta[property="og:url"]', {
        property: "og:url",
        content: SITE_URL
    });
    setMetaTag('meta[property="og:image"]', {
        property: "og:image",
        content: `${SITE_URL}/logo.png`
    });
    setMetaTag('meta[property="og:image:alt"]', {
        property: "og:image:alt",
        content: "Logo da Mango Software House"
    });
    setMetaTag('meta[name="twitter:title"]', {
        name: "twitter:title",
        content: DEFAULT_PAGE_TITLE
    });
    setMetaTag('meta[name="twitter:description"]', {
        name: "twitter:description",
        content: DEFAULT_OG_DESCRIPTION
    });
    setMetaTag('meta[name="twitter:card"]', {
        name: "twitter:card",
        content: "summary_large_image"
    });
    setMetaTag('meta[name="twitter:image"]', {
        name: "twitter:image",
        content: `${SITE_URL}/logo.png`
    });
    setLinkTag('link[rel="canonical"]', {
        rel: "canonical",
        href: SITE_URL
    });

    removeMetaTag('meta[property="article:published_time"]');
    removeMetaTag('meta[property="article:modified_time"]');
    removeMetaTag('meta[property="article:section"]');
}

export {
    SITE_URL,
    DEFAULT_PAGE_TITLE,
    DEFAULT_PAGE_DESCRIPTION,
    DEFAULT_OG_DESCRIPTION,
    absoluteUrl,
    setMetaTag,
    removeMetaTag,
    setLinkTag,
    setStructuredData,
    removeStructuredData,
    restoreDefaultMeta
};
